import { Injectable } from '@angular/core';
import { iUser } from '../interfaces/user';
import { HttpClient } from '@angular/common/http';
import { AppService } from './app.service';
import { BillingAddress } from '../interfaces/billing-address';
import { Observable, tap } from 'rxjs';
import { PackService } from './pack.service';


@Injectable({
	providedIn: 'root'
})
export class UserService {


	public user: iUser


	constructor(
		private appService: AppService,
		private http: HttpClient,
		private packService: PackService
	) {
	}


	/**
	 * Retrieves the user data from the API endpoint.
	 *
	 * @returns {Observable<any>} An observable that emits the user data.
	 */
	public getUserData(): Observable<iUser> {
		const url = this.appService.getApiEndpoint() + '/oauth/me';
		const body = {};

		return this.http.post<iUser>(url, body).pipe(
			tap((userData: iUser) => {
				if (!userData) {
					userData = {} as iUser;
					this.packService.loadAllUsersPacks()
				}
			})
		);
	}


	public saveUserBillingAddress(billingAddress: BillingAddress) {
		const url = this.appService.getApiEndpoint() + '/oauth/update-billing-address'
		return this.http.post(url, billingAddress)
	}

}
